import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../core/services';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-rest-password',
  templateUrl: './rest-password.component.html',
  styleUrls: ['./rest-password.component.css']
})
export class RestPasswordComponent implements OnInit {
  restForm: FormGroup;
  token: string;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) {

    this.route.params.subscribe(params => {
      if (params.token) {
        this.token = params.token;
      }
    });

    this.restForm = this.fb.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    }, {validator: passwordMatchValidator});
  }

  ngOnInit() {
  }

  submit() {
    if (this.restForm.invalid) {
      return;
    }
    this.spinner.show('auth');
    this.authService.resetPassword({token: this.token, password: this.restForm.get('password').value})
      .subscribe( res => {
        this.spinner.hide('auth');
        if (res.success) {
         this.authService.setAuth(res.user);
         this.router.navigateByUrl('/');
        }
      });
  }

}

function passwordMatchValidator(frm: FormGroup) {
  return frm.get('password').value ===
  frm.get('confirmPassword').value ? null : {mismatch: true};
}
